module.exports = __webpack_public_path__ + "static/media/signup-img.2dbc9cf1.jpg";